import { payinAccountType } from '@transfeeradev/api-enums/payinApi';

export const accountTypes = {
  [payinAccountType.own]: 'Transfeera',
  [payinAccountType.thirdParty]: 'Outros'
};
